import animatedLogo from '../../assets/logo/bloomays_animated_logo.svg';
import staticLogo from '../../assets/logo/bloomays_static_logo.svg';

const LoadingLogo = ({ animated = true }: { animated?: boolean }): React.ReactElement => {
  const animatedlogoStyles: React.CSSProperties = {
    height: '6vmin',
    pointerEvents: 'none' as const,
    margin: '20px',
  };

  const staticLogoStyles: React.CSSProperties = {
    height: '10vmin',
    pointerEvents: 'none' as const,
    margin: '20px',
  };

  if (!animated) {
    return (<img src={staticLogo} style={staticLogoStyles} alt="logo" />) as React.ReactElement;
  }
  return (<img src={animatedLogo} style={animatedlogoStyles} alt="logo" />) as React.ReactElement;
};

export default LoadingLogo;
export { LoadingLogo };
